export enum InitRoute {
  selectEnterprise = 'select-enterprise',
  dashboard = 'dashboard',
  profile = 'profile',
  inventory = 'inventory',
  fiscal = 'fiscal',
  rbac = 'rbac',
}
